export const CONNECT_TO_WEBSOCKET = 'CONNECT_TO_WEBSOCKET';
export const SET_WEBSOCKET = 'SET_WEBSOCKET';
export const AUTHENTICATE = 'AUTHENTICATE';